import { Token } from './token.model';
import { Utils } from './../utils/utils';
import { PETICIONES, DELAY, STORAGE } from './../utils/constants';
import { User } from './user.model';
import { Credenciales } from '../../core/entities/credenciales.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
//import 'rxjs/Rx';
import * as _ from 'lodash';

@Injectable()
export class AuthenticationService {

  readonly BASE: any = PETICIONES.login;
  readonly BASELOGINPASSWORD: any = PETICIONES.users;
  readonly headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
  private _user: User = null;

  constructor(private http: HttpClient) { }

  /**
   * @description
   * Hace el login
   * @param credenciales Usuario y contraseña (sin cifrar) para hacer el login
   */
  public doLogin(credenciales: Credenciales): Observable<any> {
    const json = JSON.stringify(credenciales);
    return this.http.post(this.BASE.login, json, { headers: this.headers }).pipe(delay(DELAY));
  }

  /**
   * @description
   * Hace el login con usuario y contraseña
   * @param credenciales Usuario y contraseña (sin cifrar) para hacer el login con password
   */
  public doLoginPassword(credenciales: Credenciales): Observable<any> {
    const json = JSON.stringify(credenciales);
    return this.http.post(this.BASELOGINPASSWORD.login, json, { headers: this.headers }).pipe(delay(DELAY));
  }

  /**
   * @description
   * Comprueba si hay sesión activa
   */
  public isLogged(): Observable<any> {
    return this.http.get(this.BASE.isLogged, { headers: this.headers }).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene de nuevo los token de acceso y refresco con el de refresco en la cabecera
   */
  public doRefresh(): Observable<any> {
    return this.http.get(this.BASE.refresh, { headers: this.headers }).pipe(delay(DELAY));
  }

  /**
   * @description
   * Elimina la sesión
   */
  public doLogout(): Observable<any> {
    localStorage.removeItem(STORAGE.USUARIO);
    localStorage.removeItem(STORAGE.DATE);
    localStorage.removeItem(STORAGE.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE.IP);
    this._user = null;
    return of(true);
  }

  /**
   * Guarda el usuario y los tókenes en el localstorage
   * @param username Nombre de usuario
   * @param access Token de acceso
   * @param refresh Token de refresco
   */
  public saveUser(username: string, access: string, refresh: string, allrols: any, idempresa: string, tokenws: string) {
    //localStorage.setItem(STORAGE.DATE_ANT, this._user.dateant + '');
    const date = new Date().getTime();
    this._user = new User(username, access, refresh, date);
    localStorage.setItem(STORAGE.USUARIO, username);
    localStorage.setItem(STORAGE.DATE, date + '');
    localStorage.setItem(STORAGE.ACCESS_TOKEN, access);
    localStorage.setItem(STORAGE.REFRESH_TOKEN, refresh);
    localStorage.setItem(STORAGE.DBOID, null);
    var rolsParse = JSON.stringify(allrols);
    localStorage.setItem(STORAGE.ALLROLS, rolsParse);
    localStorage.setItem(STORAGE.IDEMPRESA, idempresa);
    localStorage.setItem(STORAGE.TOKENWS, tokenws);
    localStorage.setItem(STORAGE.DATE_ANT, new Date().getTime() + '');
  }

  /**
   * Guarda el usuario y los tókenes en el localstorage
   * @param tokenValid Objeto en BD del token valid
   * @param access Token de acceso
   * @param refresh Token de refresco
   */
  //public saveUserValid(tokenValid: TokenValid, access: string, refresh: string) {
  public saveUserValid(tokenValid: any, access: string, refresh: string) {
    this.saveUser(tokenValid.name + " " + tokenValid.surnames, access, refresh, null, "", "");
    localStorage.setItem(STORAGE.VALID_TOKEN, JSON.stringify(tokenValid));
    //localStorage.setItem(STORAGE.VALID_TOKEN, tokenValid);
  }

  /**
   * Guarda el id del registro Valid en BD
   * @param id Id del registro Valid en BD
   */
  public saveIdValid(id: string) {
    localStorage.setItem(STORAGE.VALID_ID, id);
  }

  /**
   * Recupera el usuario y los tókenes del localstorage
   */
  public retrieveUser() {
    const username = localStorage.getItem(STORAGE.USUARIO);
    const date = localStorage.getItem(STORAGE.DATE);
    const access = localStorage.getItem(STORAGE.ACCESS_TOKEN);
    const refresh = localStorage.getItem(STORAGE.REFRESH_TOKEN);
    this._user = new User(username, access, refresh, +date);
  }

  public changeTokens(tokens: Token) {
    localStorage.setItem(STORAGE.ACCESS_TOKEN, tokens.accessToken);
    localStorage.setItem(STORAGE.REFRESH_TOKEN, tokens.refreshToken);
    this._user.token = _.cloneDeep(tokens);
  }

  /**
   * Elimina todos los datos guardados de valid
   */
  public cleanValid() {
    localStorage.removeItem(STORAGE.VALID_ID);
    localStorage.removeItem(STORAGE.VALID_TOKEN);
  }

  /**
   * Devuelve el nombre del usuario logueado
   */
  public getUsername() {
    return Utils.noUndfAndNull(this._user) ? this._user.username : '';
  }

  /**
   * Devuelve el token de acceso
   */
  public getAccessToken() {
    return Utils.noUndfAndNull(this._user) ? this._user.getAccessToken() : '';
  }

  /**
   * Devuelve el token de refresco
   */
  public getRefreshToken() {
    return Utils.noUndfAndNull(this._user) ? this._user.getRefreshToken() : '';
  }

  /**
   * Devuelve el id del registro Valid en BD
   */
  public getIdValid() {
    return localStorage.getItem(STORAGE.VALID_ID);
  }

}
